/* istanbul ignore next */

/**
 * Implementation of the xmlHttpclient converting eventhandlers to callbacks (For internal use)
 */
export interface IHttpRequestExecutor {

    /**
     * execte the Http GET call
     * @param url The url to point the request to
     * @param httpheaders (optional) The httpHeaders array to append to the request
     * @param success (optional) The callback after a succesfull request
     * @param error (optional) The callback after a failed request
     */
    executeHttpGet(url: string, httpHeaders?: Array<any>,
        success?: (responseText: string) => void,
        error?: (responseText: string, statusCode: number) => void): void;
}

/** This is just to force the compiler to generate .d.ts for interfaces */
export function _IHttpRequestExecutor(): void { } export default IHttpRequestExecutor;